import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useFetch from 'use-http';
import { format } from 'date-fns';
import { Button } from '@/components/ui/button';
import { DataTable } from '@/v2/components/DataTable/tasks/components/data-table';
import { DataTableColumnHeader } from '@/v2/components/DataTable/tasks/components/data-table-column-header';
import _ from 'lodash';

export default function DutyDoctorHistoryTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const { get: getData, response: getDataResponse } = useFetch(
    '/LocalRegistration/GetLocalRegistrations',
  );

  const handleSelection = (registration) => {
    setLoading(true);
    history.push('/registration/local/details', { registration });
    setLoading(false);
  };

  const fetchData = async () => {
    setLoading(true);
    const result = await getData();
    if (getDataResponse.ok) {
      setData(_.orderBy(result ?? [], ['createdAt'], ['desc']));
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <DataTable
      title="Kreipimųsi istorija"
      columns={columns({ handleSelection })}
      data={data}
      filterableColumns={['topic', 'createdAt']}
    />
  );
}

const columns = ({ handleSelection }) => [
  {
    accessorKey: 'topic',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="TEMA" />
    ),
    cell: ({ row }) => (
      <span
        className="font-medium max-w-[400px] truncate cursor-pointer hover:underline"
        onClick={() => handleSelection(row.original)}
      >
        {row.original.topic}
      </span>
    ),
  },
  {
    accessorKey: 'createdAt',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="SUKŪRIMO DATA" />
    ),
    cell: ({ row }) => (
      <span
        className="text-muted-foreground cursor-pointer"
        onClick={() => handleSelection(row.original)}
      >
        {format(new Date(row.original.createdAt), 'yyyy-MM-dd')}
      </span>
    ),
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleSelection(row.original)}
        >
          Peržiūrėti
        </Button>
      </div>
    ),
  },
];
